export default __webpack_public_path__ + "static/media/Rival-Parent-Logo.99b3b232.png";